// extracted by mini-css-extract-plugin
module.exports = {"container":"Kf-z","heading":"Lf-z","links":"Mf-z","linkBtn":"Nf-z","disabled":"Of-z","linkUppercaseBold":"Pf-z","copy":"Qf-z","subCopy":"Rf-z"};